import { AutoComplete, Button, Col, Form, Input, Modal, Row, Select, Tooltip } from 'antd';
import React, { Dispatch, useEffect, useState } from 'react';
import { DeleteOutlined, PaperClipOutlined } from '@ant-design/icons';
import { ContainerAnexo } from '../styles';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'redux';
import { ApplicationState } from '../../../../../../../../../store';
import { loadRequest as loadCidades } from '../../../../../../../../../store/ducks/cidadeOrigem/actions';
import SelectTipoVolume from '../../../../../../../../../components/SelectTipoVolume';
import api from '../../../../../../../../../service/api';
import { SKW_PREFIX } from '../../../../../../../../../utils/constants';
import saveAs from 'file-saver';
import { FieldData } from '../types';
import Swal from 'sweetalert2';

interface CustomizedFormProps {
  onChange: (fields: FieldData[]) => void;
  fields: FieldData[];
  disabled: boolean;
  data: any;
  anexos: any;
  handleDeleteAnexo: (id: any) => void;
  setAnexos: (data: any) => void;
  setChaveNfe: React.Dispatch<React.SetStateAction<string>>;
  setTipoVolume: React.Dispatch<React.SetStateAction<string>>;
  setQtdVolume: React.Dispatch<React.SetStateAction<number>>;
  setPesoBruto: React.Dispatch<React.SetStateAction<any>>;
  setValor: React.Dispatch<React.SetStateAction<any>>;
  setNomeCidadeOrigem: React.Dispatch<React.SetStateAction<string>>;
  setCodCidadeOrigem: React.Dispatch<React.SetStateAction<number>>;
  setObservacao: React.Dispatch<React.SetStateAction<string>>;
}

const CustomizedForm: React.FC<CustomizedFormProps> = ({
  onChange,
  fields,
  disabled,
  setChaveNfe,
  setTipoVolume,
  setQtdVolume,
  setPesoBruto,
  setValor,
  setNomeCidadeOrigem,
  setCodCidadeOrigem,
  setObservacao,
  data,
  anexos,
  handleDeleteAnexo,
}) => {
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const dispatch = useDispatch<Dispatch<Action>>();
  const cidade = useSelector((state: ApplicationState) => state.CidadeOrigem.data);
  const { Option } = AutoComplete;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [src, setSrc] = useState<string>('');

  useEffect(() => {
    dispatch(loadCidades());
  }, [dispatch]);

  const handleSelect = (value: string, e: any) => {
    setNomeCidadeOrigem(value);
    setCodCidadeOrigem(e.key);
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  const baixarArquivo = (nuNota: number, name: string) => {
    api
      .post(
        `call?serviceName=${SKW_PREFIX}baixarAnexoNota&token=${token}`,
        {
          nunota: nuNota,
          arquivo: name,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .then((res) => {
        const file = new File([res.data], name, {
          type: 'aplication/octet-stream',
        });
        saveAs(file);

        // const blob = new Blob([`${res.data}`], {
        //   type: 'application/octet-stream',
        // });
        // saveAs(blob, name);
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao baixar o arquivo',
          text: 'Tente novamente',
        });
      });
  };

  const onPreview = async (nuNota: any) => {
    anexos.map((anexo: any) => {
      if (anexo.nuNota.toString() === data.nuNota.toString()) {
        setSrc(anexo?.base64);
        anexo.name.split('.')[1] === 'png' ||
        anexo.name.split('.')[1] === 'jpg' ||
        anexo.name.split('.')[1] === 'jpeg'
          ? setOpenModal(true)
          : baixarArquivo(Number(anexo.nuNota), anexo.name);
        return anexo;
      }
      return null;
    });
  };

  return (
    <>
      <Form
        autoComplete="off"
        name="global_state"
        layout="vertical"
        fields={fields}
        onFieldsChange={(_, allFields) => {
          onChange(allFields);
        }}
      >
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item name="chaveNfe" label="Chave da nota fiscal">
              <Input
                disabled={disabled}
                onChange={(e: any) => setChaveNfe(e.target.value?.replace(/[a-z | A-Z]/g, ''))}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={12}>
            <Tooltip title={!disabled ? 'Não é possível alterar o tomador' : ''}>
              <Form.Item
                name="tomador"
                label="Tomador"
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <Input disabled={true} />
              </Form.Item>
            </Tooltip>
          </Col>
          <Col span={12}>
            <Tooltip title={!disabled ? 'Não é possível alterar o fornecedor' : ''}>
              <Form.Item
                name="fornecedor"
                label="Fornecedor"
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <Input disabled={true} />
              </Form.Item>
            </Tooltip>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={8}>
            <SelectTipoVolume
              label="Tipo de volume"
              setName="tipoVolume"
              setRequired={true}
              setTipoVolume={setTipoVolume}
              disabled={disabled}
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="qtdVolume"
              label="Quantidade"
              rules={[{ required: true, message: 'Por favor preencha este campo' }]}
            >
              <Input
                disabled={disabled}
                onChange={(e: any) =>
                  setQtdVolume(e.target.value?.replace(/[a-z | A-Z]/g, '').replace(',', ''))
                }
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Tooltip title={!disabled ? 'Não é possível alterar o número da nota fiscal' : ''}>
              <Form.Item
                name="numNota"
                label="Número da nota fiscal"
                rules={[{ required: true, message: 'Por favor preencha este campo' }]}
              >
                <Input disabled={true} />
              </Form.Item>
            </Tooltip>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="pesoBruto"
              label="Peso bruto"
              rules={[{ required: true, message: 'Por favor preencha este campo' }]}
            >
              <Input
                disabled={disabled}
                onChange={(e: any) =>
                  setPesoBruto(
                    e.target.value?.replace(/[a-z | A-Z]/g, '').toLocaleString('pt-BR', {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })
                  )
                }
                suffix="KG"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="valor"
              label="Valor"
              rules={[{ required: true, message: 'Por favor preencha este campo' }]}
            >
              <Input
                disabled={disabled}
                onChange={(e: any) => setValor(e.target.value?.replace(/[a-z | A-Z]/g, ''))}
                prefix="R$"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="cidadeOrigem"
              label="Cidade de Origem"
              rules={[{ required: true, message: 'Por favor preencha este campo' }]}
            >
              <Select
                showSearch
                filterOption={(inputValue, option) =>
                  option!.value?.toUpperCase().indexOf(inputValue?.toUpperCase()) !== -1
                }
                onChange={handleSelect}
                data-testid="select"
                placeholder="Selecione a cidade"
                disabled={disabled}
              >
                {cidade?.map((item: any) => (
                  <Option
                    data-testid="select-option"
                    key={item.codCid}
                    value={item.nome + '-' + item.siglaEstado}
                  >
                    {item.nome + '-' + item.siglaEstado}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item name="observacao" label="Observações">
              <Input.TextArea
                rows={10}
                disabled={disabled}
                onChange={(e: any) => setObservacao(e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col>
            {anexos.map(
              (anexo: any) =>
                anexo.nuNota === data.nuNota.toString() && (
                  <ContainerAnexo>
                    <div className="iconAnexo">
                      <PaperClipOutlined />
                    </div>
                    <div className="arquivo" onClick={() => onPreview(anexo.nuNota)}>
                      {anexos.map(
                        (anexo: any) => anexo.nuNota === data.nuNota.toString() && anexo.name
                      )}
                    </div>
                    <Tooltip title={disabled ? '' : 'Excluir anexo'}>
                      <Button
                        icon={<DeleteOutlined />}
                        className="delete"
                        onClick={() => handleDeleteAnexo(anexo.nuNota)}
                        disabled={disabled}
                      ></Button>
                    </Tooltip>
                  </ContainerAnexo>
                )
            )}
          </Col>
        </Row>
      </Form>
      <Modal visible={openModal} title={''} footer={[]} onCancel={handleCancel}>
        <img alt="anexo" style={{ width: '100%' }} src={src} />
      </Modal>
    </>
  );
};

export default CustomizedForm;
